
const env = process.env;
const development: boolean = !env.NODE_ENV || env.NODE_ENV === 'development';

export class MyConfig{
    public static isDevEnv: boolean = development;
    public static idServerUrl: string = env.REACT_APP_ID_SERVER_URL;
}

export default function isDev(): boolean
{
    return development;
}